// english

export default {
  system_dashboard: 'System Dashboard',
  system_dashboard_user: 'User Statistics',
  system_dashboard_user_total: 'Total Users',
  system_dashboard_user_online: 'Online Users',
  system_dashboard_user_disabled: 'Disabled Users',
  system_dashboard_customer: 'Customer Statistics',
  system_dashboard_customer_total: 'Total Customers',
  system_dashboard_device_model: 'Device Model Statistics',
  system_dashboard_device_model_total: 'Total Device Model',
  system_dashboard_info: 'System Information',
  system_dashboard_info_mysql: 'Mysql db',
  system_dashboard_info_mqtt: 'MQTT',
  system_dashboard_info_nps: 'NPS',
  system_dashboard_info_redis: 'Redis',
  system_dashboard_info_frontend: 'Frontend',
  system_dashboard_info_backend: 'Backend',

  system_dashboard_system_events: 'Recent system events',
  system_dashboard_system_events_types: {
    0: 'Disconnect',
    1: 'Minor Alarm',
    2: 'Alarm',
    3: 'Unavailable.',
  },
  system_dashboard_system_events_table_sn: 'SN',
  system_dashboard_system_events_table_status: 'Status',
  system_dashboard_system_events_table_type: 'Type',
  system_dashboard_system_events_table_start_time: 'Start Time',
  system_dashboard_system_events_table_end_time: 'End Time',
  system_dashboard_recent_user: 'Recent user',

  system_dashboard_recent_customer: 'Recent customer',
  system_dashboard_recent_device_model: 'Recent device model',
  system_dashboard_table_open: 'Open',
  system_dashboard_table_ended: 'Ended',
};
